import { add, isAfter } from "@utils/date";

import { getBonusCardRequestedState } from "@services/bonusCard.service";

export const hasLocalStorageTimestamp = (email: string) => {
    const state = getBonusCardRequestedState();
    if (!state) {
        return false;
    }

    const stateForEmail = state.find(s => s.email === email);

    if (!stateForEmail) {
        return false;
    }

    const dateTimestamp = new Date(parseInt(stateForEmail.timeStamp));

    return isAfter(add(dateTimestamp, { days: 14 }), new Date());
};

export const isEBonusCard = (bonusCard?: string | null) => {
    return new RegExp(/^(2499)(\d{9})$/).test(bonusCard || "");
};
